export default __webpack_public_path__ + "48d75824d93d4d19f4fe3a89ddda5a50.pdf";